import React, { useState, useEffect } from "react";
import ProductDetails from "../ProductDetails/ProductDetails"; // تأكد من المسار الصحيح
import "./Cake.css";

const commonStyles = {
  container: "layout_container",
  headerWrapper: "Header_wrapper",
  headerSubtitle: "Header_subtitle",
  headerTitle: "Header_title",
};

const SectionHeader = ({ title, subtitle }) => (
  <div className={commonStyles.headerWrapper}>
    <span className={commonStyles.headerSubtitle}>{subtitle}</span>
    <h2 className={commonStyles.headerTitle}>{title}</h2>
  </div>
);

const Cake = () => {
  const [activeFilter, setActiveFilter] = useState("marshmallow");
  const [selectedProduct, setSelectedProduct] = useState(null); // حالة المنتج المختار

  const filters = [{ id: "marshmallow", label: "كيك مع المارشميلو" }];

  const products = [
    {
      id: 1,
      name: "Hugy Moosh Milk",
      category: "marshmallow",
      description: "كيك الحليب مع المارشميللو المغطس بالشوكولا",
      weight: "30g",
      packaging: " 12 علبة / طرد - 12 قطعة / علبة",
      ingredients: [
        "سكر",
        "زيوت نباتية مهدرجة",
        "مياه",
        "دقيق القمح (دقيق الطحين)",
        "جلوكوز",
        "كاكاو طبيعي",
        "كتلة الكاكاو",
        "بيض",
        "حليب خالي الدسم",
        "حليب كامل الدسم",
        "مصل الحليب",
        "سوربيتول",
        "جيلاتين بقري",
        "نشاء معدل",
        "ديكستروز",
        "ليستين الصويا E322",
        "غلسرين",
        "كيك جيل",
        "بيروفوسفات الصوديوم (مواد رافعة)",
        "بيكربونات الصوديوم (مواد رافعة)",
        "ملح الطعام",
        "نكهات (فانيليا، حليب، زبدة)",
        "سوربات بوتاسيوم (مادة حافظة)",
        "بروبلين جليكول",
      ],
      images: [
        "/images/Product3/HugyMooshWhite1.webp",
        "/images/Product3/HugyMooshWhite2.webp",
        "/images/Product3/HugyMooshWhite3.webp",
      ],
      img: "/images/Product3/HugyMooshWhiteEaten.webp",
    },
    {
      id: 2,
      name: "Hugy Moosh Dark",
      category: "marshmallow",
      description: "كيك الشوكولا مع المارشميللو المغطس بالشوكولا",
      weight: "30g",
      packaging: "12 علبة / الطرد - 12 قطعة / العلبة",
      ingredients: [
        "سكر",
        "زيوت نباتية مهدرجة",
        "مياه",
        "دقيق القمح",
        "جلوكوز",
        "كاكاو طبيعي",
        "كتلة الكاكاو",
        "بيض طازج",
        "حليب خالي الدسم",
        "حليب كامل الدسم",
        "مصل الحليب",
        "سوربيتول (مرطب)",
        "جيلاتين بقري حلال",
        "نشاء معدل",
        "ديكستروز",
        "غلسرين",
        "كيك جيل",
        "ملح الطعام",
        "بروبلين جليكول",
        "ليستين الصويا E322 (مستحلب)",
        "بيروفوسفات الصوديوم (مواد رافعة)",
        "بيكربونات الصوديوم (مواد رافعة)",
        "منكهات (فانيليا، حليب، زبدة)",
        "سوربات بوتاسيوم (مادة حافظة)",
      ],
      images: [
        "/images/Product2/HugyMooshDark1.webp",
        "/images/Product2/HugyMooshDark2.webp",
        "/images/Product2/HugyMooshDark3.webp",
      ],
      img: "/images/Product2/HugyMooshDarkEaten.webp",
    },
  ];

  const filteredProducts = products.filter((p) => p.category === activeFilter);

  useEffect(() => {
    if (!selectedProduct) {
      const observerOptions = { threshold: 0.1 };
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
          }
        });
      }, observerOptions);

      const cards = document.querySelectorAll(".Catalog_card");
      cards.forEach((card) => observer.observe(card));
      return () => observer.disconnect();
    }
  }, [filteredProducts, selectedProduct]);

  // إذا كان هناك منتج مختار، اعرض صفحة التفاصيل
  if (selectedProduct) {
    return (
      <ProductDetails
        product={selectedProduct}
        onBack={() => setSelectedProduct(null)}
      />
    );
  }

  return (
    <div className="biscuit-container">
      <div className={commonStyles.container}>
        <SectionHeader title="تصفح منتجات البسكويت" subtitle="جودة وفخامة" />

        <div className="Catalog_filterWrapper">
          {filters.map((filter) => (
            <button
              key={filter.id}
              className={`Catalog_filterBtn ${
                activeFilter === filter.id ? "Catalog_filterBtnActive" : ""
              }`}
              onClick={() => setActiveFilter(filter.id)}
            >
              {filter.label}
            </button>
          ))}
        </div>

        <div className="Catalog_grid">
          {filteredProducts.map((product) => (
            <div
              key={product.id}
              className="Catalog_card"
              onClick={() => setSelectedProduct(product)} // عند النقر، يتم اختيار المنتج
              style={{ cursor: "pointer" }}
            >
              <div className="Catalog_imgContainer">
                <img
                  src={product.img}
                  alt={product.name}
                  className="Catalog_img"
                />
              </div>
              <div className="Catalog_info">
                <h4 className="Catalog_name">{product.name}</h4>
                <div className="Catalog_desc">
                  <p>{product.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Cake;
